window.purchaseTogetherHandler = () => {
  /* ---------- Live‑updating price ---------- */
  const totalEl   = document.querySelector('.total-price-combination');
  if (totalEl) {
    const baseCents = parseInt(totalEl.dataset.basePrice, 10);

    const formatMoney = cents =>
    new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: window.shopCurrency || 'USD',
        minimumFractionDigits: 2
    }).format(cents / 100);


    const recalcTotal = () => {
      let total = baseCents;
      document.querySelectorAll('.add-on-checkbox').forEach(cb => {
        if (cb.checked && !cb.disabled) total += parseInt(cb.dataset.price, 10);
      });
      totalEl.textContent = `Total ${formatMoney(total)}`;
    };

    /* Initial render + listen for changes */
    recalcTotal();
    document.addEventListener('change', e => {
      if (e.target.matches('.add-on-checkbox')) recalcTotal();
    });
  }
  /* ---------- End live‑updating price ---------- */

  /* ---------- Existing custom ATC logic ---------- */
  function getSectionInnerHTML(htmlString, selector = '.shopify-section') {
    const parsed = new DOMParser()
      .parseFromString(htmlString, 'text/html')
      .querySelector(selector);
    return parsed ? parsed.innerHTML : '';
  }
  function getSectionsToRender() {
    return [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble' }
    ];
  }
  function renderContents(response) {
    getSectionsToRender().forEach(section => {
      const html    = getSectionInnerHTML(response.sections[section.id], section.selector);
      const target  = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (target) target.innerHTML = html;
    });

    const cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl) {
      cartDrawerEl.classList.remove('is-empty');
      cartDrawerEl.classList.add('animate', 'active');
      setTimeout(() => {
        const overlay = cartDrawerEl.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', cartDrawerEl.close.bind(cartDrawerEl));
        requestAnimationFrame(() => { if (typeof cartDrawerEl.open === 'function') cartDrawerEl.open(); });
      }, 50);
    }
  }
  function customATCHandler(items) {
    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items,
        sections: ['cart-drawer', 'cart-icon-bubble']
      })
    })
      .then(res => res.json())
      .then(renderContents)
      .catch(err => console.error('Error adding to cart:', err));
  }
  const customBtn = document.querySelector('.custom-atc-button');
  if (customBtn) {
    customBtn.addEventListener('click', e => {
      e.preventDefault();
      const items = [];
      document.querySelectorAll('.add-on-checkbox').forEach(cb => {
        if (cb.checked) items.push({ id: parseInt(cb.dataset.value, 10), quantity: 1 });
      });
      if (items.length) customATCHandler(items);
    });
  }
  /* ---------- End custom ATC logic ---------- */
}
document.addEventListener('DOMContentLoaded', () => {
  window.purchaseTogetherHandler();
});
